
 import PricingButton from "@/components/main/pricing/PricingButton";
 import RedHeadBox from "@/components/main/core/RedHeadBox";
 import PricingQuestion from "@/components/main/core/PricingQuestion";
 import TabsButtonsPricing from "@/components/main/tabs/TabsButtonsPricing";
 export default {
   name: "ListingLocatorTab",
   components: { PricingButton, RedHeadBox, PricingQuestion, TabsButtonsPricing },
   data() {
     return {
       current: 2,
     }
   },

   methods: {
     change(id) {
       this.current = id;
     }
   }
 }
 